/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/react'
import { Container, Row, Col } from 'react-grid-system'

import AboutUsCTAButtons from './AboutUsCTAButtons'
import ImageResponsive from '../images/ImageResponsive'
import H1 from '../typography/H1'
import H3 from '../typography/H3'
import HR from '../misc/HR'
import P2 from '../typography/P2'
import theme, { mq } from '../../theme'

interface SectionColumnProps {
  title: string
  children: React.ReactNode
}

const SectionColumn: React.FC<SectionColumnProps> = (props) => {
  const { title, children } = props
  return (
    <div>
      <H3>{title}</H3>
      <P2>{children}</P2>
    </div>
  )
}

interface Props {
  img: string
}

const AboutUsSection7: React.FC<Props> = (props) => {
  const { img } = props
  const title1 = 'Easy Elevations'
  const title2 = 'A Myriad of Options'
  const title3 = 'Share and Ship'

  return (
    <div
      css={{
        backgroundColor: 'white',
        padding: '4em 0px',
        textAlign: 'center',
      }}
    >
      <Container>
        <div css={{ maxWidth: '1111px', display: 'inline-block' }}>
          <H1 css={{ marginBottom: '2em' }}>Key Features</H1>
          <ImageResponsive src={img} alt="" />
          <Row style={{ marginTop: '2em' }}>
            <Col xs={12} md={4}>
              <SectionColumn title={title1}>
                Say goodbye to time-consuming shelving and styling
                visualisations with our multiple object placement tools.
              </SectionColumn>
            </Col>
            <Col xs={12} md={4}>
              <SectionColumn title={title2}>
                Browse our online catalogue of thousands of design and art
                objects to create a perfectly curated wall or shelf!
              </SectionColumn>
            </Col>
            <Col xs={12} md={4}>
              <SectionColumn title={title3}>
                Easily share your selections with your team or client for
                approval and invoicing.
              </SectionColumn>
            </Col>
          </Row>

          <div
            css={{
              maxWidth: '90%',
              marginTop: '4em',
              marginBottom: '4em',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <HR />
          </div>

          <AboutUsCTAButtons />
        </div>
      </Container>
    </div>
  )
}

export default AboutUsSection7
